import axios, { AxiosResponse } from 'axios';
import { camelizeKeys } from 'humps';

import useTenant from 'stores/useTenant';
import useUser from 'stores/useUser';

function api() {
  const creator = axios.create;
  const { token, user, setLogout } = useUser.getState();
  const { tenant } = useTenant.getState();
  const instance = creator({
    baseURL: process.env.REACT_APP_BASE_URL.concat('/admin/v1/'),
    headers: { authorization: `Bearer ${token}`, 'Accept-Language': 'pt-BR' },
  });
  instance.interceptors.request.use(
    async (config) => {
      const headers = {
        ...config.headers,
      };
      if (user?.tenantId || tenant?.id) {
        headers.tenant = user?.tenantId ?? tenant?.id;
      }
      return {
        ...config,
        headers,
        params: config.params,
      };
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (config) => camelizeKeys(config) as AxiosResponse<any>,
    (error) => {
      if (error.response?.status === 401) {
        setLogout();
      }
      if (error.response?.status === 403) {
        window.location.replace('/403');
      }
      return Promise.reject(error.response?.data || error);
    },
  );

  return instance;
}

export default api;
